import { RouteConfig } from 'vue-router';
import { AdminRoles } from '@/configs/role';

const bannerRoutes: RouteConfig = {
  path: 'banner',
  component: () => import(/* webpackChunkName: 'dashboard.banner' */ '@/pages/banner/Index.vue'),
  redirect: {
    name: 'banner-list',
  },
  children: [
    {
      path: 'list',
      name: 'banner-list',
      component: () => import(/* webpackChunkName: 'dashboard.banner' */ '@/pages/banner/List.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
    {
      path: 'create',
      name: 'banner-create',
      component: () => import(/* webpackChunkName: 'dashboard.banner' */ '@/pages/banner/Edit.vue'),
      meta: {
        action: 'create',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
    {
      path: ':bannerId/edit',
      name: 'banner-edit',
      component: () => import(/* webpackChunkName: 'dashboard.banner' */ '@/pages/banner/Edit.vue'),
      meta: {
        action: 'edit',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
  ],
};

export default bannerRoutes;
